import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';
import { URLS } from 'constants/api.constants';

export const postGet = createAsyncThunk(
  'post/postget',
  async (
    { sortBy = 0, page = 1, tag_name = null, group_id = null },
    thunkAPI
  ) => {
    try {
      const response = await axiosInstance.get(`${URLS.POSTS.GET_POSTS}`, {
        params: { sortBy, page, tag_name, group_id },
      });

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const createPost = createAsyncThunk(
  'post/createpost',
  async (params = {}, thunkAPI) => {
    try {
      // console.log(params)
      const response = await axiosInstance.post(URLS.POSTS.CREATE_POST, params);

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const editPost = createAsyncThunk(
  'post/editpost',
  async ({ post_id, data }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${URLS.POSTS.EDIT_POST}/${post_id}`,
        data,
        {
          headers: {
            'Content-Type': 'application/form-data',
          },
        }
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const getTags = createAsyncThunk(
  'post/gettags',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.POSTS.GET_TAGS, params);

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const postData = createAsyncThunk(
  'post/postdata',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${URLS.POSTS.POST_DATA}/${id}`);

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const LikePost = createAsyncThunk(
  'post/likeorunlike',
  async ({ post_id, comment_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(URLS.POSTS.LIKE_POSTS, {
        post_id,
        comment_id,
      });
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to like/unlike'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while liking/unliking the post'
      );
    }
  }
);

export const likeList = createAsyncThunk(
  'post/listlikes',
  async (user_id, thunkAPI) => {
    try {
      const payload = JSON.stringify({ user_id });
      const response = await axiosInstance.post(
        URLS.POSTS.GET_ACTIVITY,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch data'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching the post'
      );
    }
  }
);

export const addComment = createAsyncThunk(
  'post/addcomment',
  async ({ post_id, comment, parent_id = null }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${URLS.POSTS.ADD_COMMENT}/${post_id}`,
        { comment, parent_id }
      );

      if (response.data?.success) {
        return {
          ...response.data,
          parent_id,
        };
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to add comment'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'An error occured while commenting'
      );
    }
  }
);

export const editComment = createAsyncThunk(
  'post/editcomment',
  async ({ comment_id, comment }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${URLS.POSTS.EDIT_COMMENT}/${comment_id}`,
        { comment }
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const deleteComment = createAsyncThunk(
  'post/deleteComment',
  async ({ comment_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${URLS.POSTS.DELETE_COMMENT}/${comment_id}`
      );
      if (response.data?.success) {
        return { comment_id };
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to delete comment'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          'An error occurred while deleting the comment'
      );
    }
  }
);

export const getComment = createAsyncThunk(
  'comment/getcomment',
  async ({ post_id, page = 1, limit = 10 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.POSTS.LIST_COMMENTS}/${post_id}`,
        {
          params: {
            page,
            limit,
          },
        }
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch post'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const reportPost = createAsyncThunk(
  'post/reportpost',
  async ({ post_id, subject, bio }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${URLS.POSTS.REPORT_POST}/${post_id}`,
        { subject, bio }
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to report post'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          'An error occurred while reporting the post'
      );
    }
  }
);

export const reportComment = createAsyncThunk('post/reportpost',async({comment_id,subject,bio},thunkAPI) => {
  try {
    const response = await axiosInstance.post(`${URLS.POSTS.REPORT_COMMENT}/${comment_id}`,{subject,bio});
    if(response.data?.success){
      return response.data;
    }else{
      return thunkAPI.rejectWithValue(
        response.data?.message || 'Failed to report comment'
      );
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.message || 'An error occurred while reporting the comment'
    );
  }
})

export const getPostDetail = createAsyncThunk(
  'post/postdetails',
  async (post_id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.POSTS.POST_DATA}/${post_id}`
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to load details'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          'An error occured while loading post data'
      );
    }
  }
);

export const deletePost = createAsyncThunk(
  '/post/deletepost',
  async (post_id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${URLS.POSTS.DELETE_POST}/${post_id}`
      );
      if (response.data?.success) {
        return { post_id };
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to delete post'
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          'An error occurred while deleting the post'
      );
    }
  }
);

export const getGroupPosts = createAsyncThunk(
  'post/getgroupposts',
  async ({ group_id, page = 1, limit = 10, search = '' }, thunkAPI) => {
    try {
      const params = { page, limit };
      if (search && search.trim()) {
        params.search = search.trim();
      }
      
      const response = await axiosInstance.get(
        `${URLS.GROUP.GET_GROUP_POSTS}/${group_id}/posts`,
        {
          params,
        }
      );

      if (response.data?.success) {
        return response.data;
      } else {
        if(response.data.error_code=="NOT_MEMBER"){
          return thunkAPI.rejectWithValue(
            response.data
          )
        }
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group posts'
        );
      }
    } catch (error) {
      console.error('Group posts API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group posts'
      );
    }
  }
);

export const getMyPosts = createAsyncThunk(
  'post/getmyposts',
  async (params = { page: 1, limit: 10 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.POSTS.GET_MY_POSTS, {
        params,
      });
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch my posts'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);

export const getMyComments = createAsyncThunk(
  'post/getmycomments',
  async (params = { page: 1, limit: 10 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.POSTS.GET_MY_COMMENTS, {
        params,
      });
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch my comments'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching post'
      );
    }
  }
);
